import { BUTTON_SIZE, DSButton } from '@repo/design-system/index'
import { COLORS } from '../../../../modules/vars'

const BlogDetailDesktopCTASection = ({ ctaList, title }) => {
  const stringData = title && `<div>${title.replace(/\\n/g, '<br />')}</div>`

  const isExternalLink = (link) => link?.includes('https://')

  return (
    <>
      {ctaList && (
        <div className={style.snsVideoSectionLayout}>
          <div className={style.snsVideoSectionTitle}>
            <div dangerouslySetInnerHTML={{ __html: stringData }} />
          </div>
          <div className={style.snsVideoSectionButton}>
            {ctaList.map((buttonItem, i) => (
              <a
                key={i}
                href={buttonItem.link}
                target={isExternalLink(buttonItem.link) ? '_blank' : '_self'}
                rel="noreferrer"
              >
                <DSButton size={BUTTON_SIZE.MD} customBgColor={COLORS.PURPLE100} onClick={() => console.log('')}>
                  <DSButton.Label customTxtColor={COLORS.PURPLE500}>{buttonItem.title}</DSButton.Label>
                </DSButton>
              </a>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default BlogDetailDesktopCTASection

const style = {
  snsVideoSectionLayout: `border-t-1 mt-[40px]`,
  snsVideoSectionTitle: `Title2-18Bd mt-[40px] text-center`,
  snsVideoSectionButton: `Body2-14Bd mt-[32px] flex flex-row justify-center gap-[16px]`,
}
